import * as React from "react";
import IField from "../../../metamodel/IField";
import {EntityFacets, EntityFilters, FieldFacet, SearchFilter} from "../../types";
import AbstractFieldVisitor from "../../../metamodel/AbstractFieldVisitor";
import ArrayField from "../../../metamodel/Fields/ArrayField";
import EnumField from "../../../metamodel/Fields/EnumField";
import ImageField from "../../../metamodel/Fields/ImageField";
import LengthIntervalField from "../../../metamodel/Fields/LengthIntervalField";
import {LengthInterval, LengthIntervalFilterField} from "./LengthIntervalFilterField";
import TextField from "../../../metamodel/Fields/TextField";
import BooleanField from "../../../metamodel/Fields/BooleanField";
import EnumFilterField from "./EnumFilterField";
import TextFilterField from "./TextFilterField";
import BooleanFilterField from "./BooleanFilterField";

export interface FilterContainerProps {
    filters: IField[],
    activeFilters: EntityFilters,
    facets: EntityFacets,
    disableFacets?: boolean,
    onChange?: (filters: EntityFilters) => void
}

export default class FilterContainer extends React.Component<FilterContainerProps> {

    private filters: IField[];

    constructor(props: FilterContainerProps) {
        super(props);
        this.filters = props.filters.filter(f => f.searchable);
        this.onChange = this.onChange.bind(this);
    }

    public render(): React.ReactNode {
        return <>
                {this.filters.map(f =>
                    new FilterBuilder(
                        this.props.activeFilters[f.id],
                        this.props.facets[f.id],
                        this.props.disableFacets || false,
                        this.onChange.bind(this, f)
                    ).build(f)
                )}
            </>
    }

    private onChange(field: IField, value: SearchFilter) {
        if (this.props.onChange) {
            this.props.onChange({ ...this.props.activeFilters, [field.id]: value})
        }
    }
}

class FilterBuilder extends AbstractFieldVisitor<React.ReactElement<any>> {
    private readonly currentValue: SearchFilter;
    private readonly facet: FieldFacet;
    private readonly disableFacet: boolean;
    private readonly onChange: (value: SearchFilter) => void;

    constructor(currentValue: SearchFilter, facet: FieldFacet, disableFacet: boolean, onChange: (value: SearchFilter) => void) {
        super();
        this.currentValue = currentValue;
        this.facet = facet;
        this.onChange = onChange;
        this.disableFacet = disableFacet;
    }

    public build = (field: IField): React.ReactElement<any> => field.accept(this);

    protected visitArrayField(field: ArrayField): React.ReactElement<any> {
        return field.innerField.accept(this);
    }

    protected visitEnumField(field: EnumField): React.ReactElement<any> {
        return <EnumFilterField key={field.id} disableFacet={this.disableFacet} selected={this.currentValue as string[] || []} facet={this.facet || {}} field={field} onChange={this.onChange}/>
    }

    protected visitImageField(field: ImageField): React.ReactElement<any> {
        throw new Error("Imagefields cannot be used for searching");
    }

    protected visitLengthIntervalField(field: LengthIntervalField): React.ReactElement<any> {
        return <LengthIntervalFilterField key={field.id} value={this.currentValue as LengthInterval} field={field} onChange={this.onChange}/>;
    }

    protected visitTextField(field: TextField): React.ReactElement<any> {
        return <TextFilterField field={field} key={field.id} value={this.currentValue as string} onChange={this.onChange}/>
    }

    protected visitBooleanField(field: BooleanField): React.ReactElement<any> {
        return <BooleanFilterField field={field} key={field.id} selected={this.currentValue as boolean | undefined} facet={this.facet || {}} onChange={this.onChange} />
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/FilterContainer.tsx